export { getMessageTypeConfig, messageTypeRegistry } from "./messageTypeRegistry";
export type { BubbleStyle, MessageTypeConfig, MessageTypeConfigRuntime, MessageTypeRegistry } from "./types";
